import { ActionType } from "models/contract/information";
import { IResponse } from "models";

export const contractInformationAction = () => {
  return {
    type: ActionType.CONTRACT_INFORMATION,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.CONTRACT_INFORMATION_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: IResponse) => {
  return {
    type: ActionType.CONTRACT_INFORMATION_SUCCESS,
    payload,
  };
};
